import { api } from "./BackendService";

export const create = (brokerId, data) =>
  api.post(`/brokers/${brokerId}/accreditations`, data);
export const edit = (brokerId, id, data) =>
  api.put(`/brokers/${brokerId}/accreditations/${id}`, data);
export const getById = (brokerId, id) =>
  api.get(`/brokers/${brokerId}/accreditations/${id}`);
export const list = (brokerId, page) =>
  api.get(`/brokers/${brokerId}/accreditations`, { params: { page: page } });
